import { useGetUserFullNameWithFallback } from '@pba/react-utils';
import type { LabelInValue, UserList } from 'models';
import { useCallback } from 'react';
import { Form, FormActions, Input, Modal } from 'ui';
import { UserSelect } from 'features/users';

export type MembersInviteFormValues = {
  communityId: string;
  users: LabelInValue[];
};

type P = {
  community: LabelInValue;
  isSubmitting: boolean;
  onCancel: () => void;
  onSubmit: (data: MembersInviteFormValues) => void;
};

const MembersInviteForm = ({ community, isSubmitting, onCancel, onSubmit }: P) => {
  const getUserFullNameWithFallback = useGetUserFullNameWithFallback();

  const createUserOption = useCallback(
    (user: UserList): LabelInValue => ({ label: getUserFullNameWithFallback(user), value: user.id }),
    [getUserFullNameWithFallback],
  );

  return (
    <Form<MembersInviteFormValues> initialValues={{ communityId: community.value }} onFinish={onSubmit}>
      <Form.Item<MembersInviteFormValues> hidden name="communityId" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item<MembersInviteFormValues> label="Members" name="users" rules={[{ required: true, type: 'array' }]}>
        <UserSelect
          autoClearSearchValue
          createOption={createUserOption}
          mode="multiple"
          query={{ excludeCommunityId: community.value }}
        />
      </Form.Item>
      <Modal.HugContent.Footer>
        <FormActions
          right={{
            children: 'Back',
            onClick() {
              onCancel();
            },
          }}
          submit={{
            children: 'Send invitations',
            loading: isSubmitting,
          }}
        />
      </Modal.HugContent.Footer>
    </Form>
  );
};

export default MembersInviteForm;
